import { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { Helmet } from 'react-helmet-async';
import { getCanonicalUrl } from "@/helpers/canonicalBuilder";
import { useSchema } from "@/core/providers/SchemaContext";

const HelmetBuilder = ({ data, preview }) => {

    const title = data.metaTitle || data.title;
    const description = data.metaDescription || data.description || 'High quality, innovative bifold, accordion, multi slide, swing and sliding doors and windows from LaCantina create an indoor/outdoor experience offering unmatched performance & value with energy efficiency';
    const keywords = data.metaKeywords || data.keyword || 'BiFold Doors, Accordion, Folding Glass, Multi Slide, Swing Doors & Windows!';
    const canonical = getCanonicalUrl(data.canonicalUrl);
  
    // Meta noIndex value from the CMS (defaults to false if not set)
    const noIndex = data.metaNoIndex || false;
    
    const [ogImage, setOgImage] = useState("https://www.lacantinadoors.com/images/common-icons/LaCantina_Logo.svg");

    useEffect(() => {

      setTimeout(() => {
        let pageMain = document.getElementsByClassName('main');
        if(pageMain[0]) {
          let firstImage = pageMain[0].querySelector('img');
          if(firstImage) setOgImage(firstImage.src);
        }
        
      }, 1000); // wait for paint... because we also had to wait for data to load...
      
    }, [data]); // waiting for data or else we get the page loader as our image...

    const { compiledSchemaFunc, fullSchema } = useSchema();

    useEffect(() => {

        const fetchData = async () => {
            try {
              await compiledSchemaFunc(data, title, description, canonical);
            } catch (error) {
              console.error("Failed to fetch data:", error);
              // Optionally handle error, for example, by setting an error state
            }
          };
      
          fetchData();

    }, [data, title, description, canonical, compiledSchemaFunc ]);

    return (
        <Helmet>
            <title>{title}</title>
            <meta name={"description"} content={description} />
            <meta name={"keywords"} content={keywords} />
            <link rel="canonical" href={canonical} />
        
            {/* Conditionally render the robots meta tag based on noIndex or preview */}
            {(noIndex || preview) && (
                <meta name="robots" content="noindex, nofollow" />
            )}
        
            <script key={"schema"} type="application/ld+json">{JSON.stringify(fullSchema)}</script>

            {/*-- SOCIAL SHARE CARDS --*/}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:url" content={canonical} />
            {/*-- Linked In (optional) --*/}
            <meta property="og:site_name" content="LaCantina Doors | High Quality Sliding, Folding, & Swing Doors" />
            {/*-- Additional Twitter Card meta tags (optional) --*/}
            <meta name="twitter:creator" content="@LaCantinaDoors" />
            <meta name="twitter:image:alt" content="LaCantina Doors | High Quality Sliding, Folding, & Swing Doors" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@LaCantinaDoors" />
            {/*--  Pinterest (optional) --*/}
            {/* <meta name="p:domain_verify" content="your_verification_code" /> */}

        </Helmet>
    )

}

HelmetBuilder.propTypes = {
    data: PropTypes.object,
    preview: PropTypes.bool,
};

export default HelmetBuilder;